import { preferences } from '@/api'

export function useNavCollapsedSetting() {
  const { data: isCollapsed } = preferences.collapsedNav.useGetPreference()

  const { mutate: setIsCollapsed } = preferences.collapsedNav.usePutPreference()

  return { isCollapsed, setIsCollapsed }
}
